import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import _isEmpty from 'lodash/isEmpty';

import {
  dictionaryType,
  dictionariesEntry,
  dictionariesColumn,
  paginationOptionsType,
} from 'types';

import UploadCSVFileModal from './components/UploadCSVFileModal';

import Header from './components/DictionaryInspectHeader';
import Content from './components/DictionaryInspectHeaderContent';

import GeneralTab from './components/DictionaryInspectGeneral';
import EntriesTab from './components/DictionariesEntries';

import './style.scss';

export default class Inspect extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onCloseUploadModal: PropTypes.func.isRequired,
    onColumnAdd: PropTypes.func.isRequired,
    onColumnDelete: PropTypes.func.isRequired,
    onColumnUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onEntriesChangePage: PropTypes.func.isRequired,
    onEntriesDeleteSelected: PropTypes.func.isRequired,
    onEntryAdd: PropTypes.func.isRequired,
    onEntryDelete: PropTypes.func.isRequired,
    onEntrySort: PropTypes.func.isRequired,
    onEntryUpdate: PropTypes.func.isRequired,
    onExport: PropTypes.func.isRequired,
    onItemDeselect: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,

    columns: PropTypes.arrayOf(dictionariesColumn),
    currentDictionary: dictionaryType,
    entries: PropTypes.arrayOf(dictionariesEntry),
    entriesPagination: paginationOptionsType,
    id: PropTypes.string,
    isExporting: PropTypes.bool,
    isLoading: PropTypes.bool,
    isLoadingEntries: PropTypes.bool,

    searchEntries: PropTypes.func,
    selectedEntries: PropTypes.arrayOf(PropTypes.string),
    toggleAllEntriesSelection: PropTypes.func,
    toggleEntrySelection: PropTypes.func,
  };

  state = {
    selectedTabIndex: 2,
    isUploadModalOpen: false,
    hasSearched: false,
  };

  componentDidMount = () => {
    const { id, onSelect } = this.props;

    if (id) {
      onSelect(id);
    }
  };

  componentWillReceiveProps = ({ id }) => {
    const { onSelect } = this.props;
    if (this.props.id !== id) {
      onSelect(id);
    }
  };

  componentWillUnmount() {
    const { onItemDeselect } = this.props;
    onItemDeselect();
  }
  // MODALS:

  handleOpenUploadModal = () => {
    this.setState({
      isUploadModalOpen: true,
    });
  };

  handleCloseUploadModal = shouldReFetchData => {
    const { onCloseUploadModal } = this.props;
    onCloseUploadModal(shouldReFetchData);
    this.setState({
      isUploadModalOpen: false,
    });
  };

  handleChangeTab = selectedTabIndex => {
    const { hasSearched } = this.state;
    const { searchEntries } = this.props;

    this.setState({
      selectedTabIndex,
    });

    if (selectedTabIndex === 2 && hasSearched) {
      searchEntries('');
    }
  };

  handleEntryChangePage = (id, desc = false) => {
    const { onEntriesChangePage } = this.props;

    onEntriesChangePage(id, desc);
  };

  handleOnSearchChange = searchTerm => {
    this.setState({ hasSearched: searchTerm !== '' });
  };

  renderModals = () => {
    const { currentDictionary } = this.props;
    const { isUploadModalOpen } = this.state;

    return (
      <React.Fragment>
        {isUploadModalOpen && (
          <UploadCSVFileModal
            dictionary={currentDictionary}
            onClose={this.handleCloseUploadModal}
          />
        )}
      </React.Fragment>
    );
  };

  // ROOT:

  render() {
    const {
      currentDictionary,
      selectedEntries,

      entries,
      entriesPagination,

      columns,

      isLoading,
      isLoadingEntries,
      isExporting,

      onClose,
      onExport,
      onDelete,
      onEntryAdd,
      onEntryDelete,
      onEntryUpdate,
      onEntrySort,

      onColumnAdd,
      onColumnUpdate,
      onColumnDelete,

      onEntriesDeleteSelected,

      toggleEntrySelection,
      toggleAllEntriesSelection,

      searchEntries,
    } = this.props;

    const { selectedTabIndex } = this.state;

    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/interactive-supports-focus */
    /* eslint-disable jsx-a11y/anchor-is-valid */

    // FIXME: Do not pass empty object for undefined properties
    if (_isEmpty(currentDictionary)) {
      return null;
    }

    return (
      <div styleName="root">
        {this.renderModals()}

        <div className="concept-tab" styleName="header">
          <div className="left-links">
            <div className="entities-inspect-sorting">
              <div className="custom-dropdown --inspect-tab inspect-features-list">
                <span className="icon icon-dictionaries" />
                <span
                  className="entity-selected-name"
                  data-test="dictionary-name-inspect"
                >
                  {currentDictionary.name}
                </span>
              </div>
            </div>
            <a
              className={cn('concept-tab__menu-item', {
                '--active': selectedTabIndex === 1,
              })}
              data-test="general-tab"
              role="button"
              onClick={() => this.handleChangeTab(1)}
            >
              General
            </a>

            <a
              className={cn('concept-tab__menu-item', {
                '--active': selectedTabIndex === 2,
              })}
              data-test="content-tab"
              role="button"
              onClick={() => this.handleChangeTab(2)}
            >
              Content
            </a>
          </div>

          <div className="right-links">
            <a
              className="concept-tab__close"
              data-test="cross-close"
              role="button"
              onClick={onClose}
            >
              <i className="icon-close" />
            </a>
          </div>
        </div>

        <div styleName="content">
          {selectedTabIndex === 1 && (
            <Header
              dictionary={currentDictionary}
              isExporting={isExporting}
              onDelete={onDelete}
              onExport={onExport}
            />
          )}

          {selectedTabIndex === 2 && currentDictionary.id && (
            <Content
              dictionary={currentDictionary}
              itemsCount={entries?.length}
              selectedEntries={selectedEntries}
              onDelete={onEntriesDeleteSelected}
              onOpenUploadModal={this.handleOpenUploadModal}
              onSearch={searchEntries}
              onSearchChange={this.handleOnSearchChange}
            />
          )}

          <div
            className={cn('concept-tab-container --dictionary-tab', {
              '--no-save-bar': selectedTabIndex === 2,
            })}
            id="entity-tab-container"
          >
            {selectedTabIndex === 1 && (
              <div className="concept-tab-content info-tab">
                <div className="entities-attributes-wrapper">
                  <GeneralTab dictionary={currentDictionary} />
                </div>
              </div>
            )}

            {selectedTabIndex === 2 && (
              <div
                className={cn('concept-tab-content dictionary-rows', {
                  archived: currentDictionary.archived,
                })}
                data-test="dictionary-rows"
              >
                <EntriesTab
                  addNewColumn={onColumnAdd}
                  addNewEntry={onEntryAdd}
                  columns={columns}
                  deleteColumn={onColumnDelete}
                  entries={entries}
                  entriesPagination={entriesPagination}
                  isLoading={isLoading}
                  isLoadingEntries={isLoadingEntries}
                  loadNextEntries={this.handleEntryChangePage}
                  removeRow={onEntryDelete}
                  saveEntry={onEntryUpdate}
                  selection={selectedEntries}
                  sortItems={onEntrySort}
                  toggleAllSelection={toggleAllEntriesSelection}
                  toggleSelection={toggleEntrySelection}
                  updateColumn={onColumnUpdate}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
